import React from 'react';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import {
  OtherOptionInputWrapper,
  RadioOptionsGroup,
  RadioOptionWrapper,
} from '../FormPreview.styles';
import { BaseInputProps } from './types';

export const CheckboxInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  inlinePlacement,
  textInputPlaceholder,
}) => (
  <RadioOptionsGroup
    $inlinePlacement={inlinePlacement}
    data-testid="form-preview-checkbox-group"
  >
    {currentQuestion.options?.map((option) => {
      const isOtherOption = option.isOtherOption;
      const isChecked =
        answers[currentQuestion.id]?.checkboxOptions?.includes(option.id) ??
        false;
      const otherOptionText =
        answers[currentQuestion.id]?.otherOptionText || '';

      return (
        <div key={option.id}>
          <RadioOptionWrapper>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={() =>
                    dispatch({
                      type: 'TOGGLE_CHECKBOX',
                      questionId: currentQuestion.id,
                      payload: option.id,
                    })
                  }
                  data-testid={`form-preview-checkbox-option-${option.id}`}
                />
              }
              label={isOtherOption ? option.text.split(' (')[0] : option.text}
              sx={{ width: '100%', margin: 0 }}
            />
          </RadioOptionWrapper>
          {isOtherOption && isChecked && (
            <OtherOptionInputWrapper>
              <TextField
                fullWidth
                value={otherOptionText}
                onChange={(e) =>
                  dispatch({
                    type: 'SET_OTHER_TEXT',
                    questionId: currentQuestion.id,
                    payload: e.target.value,
                  })
                }
                placeholder={textInputPlaceholder}
                slotProps={{
                  htmlInput: {
                    'data-testid': `form-preview-checkbox-other-input-${option.id}`,
                  },
                }}
              />
            </OtherOptionInputWrapper>
          )}
        </div>
      );
    })}
  </RadioOptionsGroup>
);
